module.exports = __webpack_public_path__ + "img/ico-redo.2a0c1ced.svg";